import BaseChip from './BaseChip';

export default BaseChip;
